export const apiMarquetURI = process.env.REACT_APP_URL
export const defaultUrlDomainName = process.env.REACT_APP_URL_DOMAIN_NAME || 'dev';

export const chargebeeUrl = `${apiMarquetURI}/chargebee`
export const hubspotUrl = `${apiMarquetURI}/hubspot`
export const tenatProvisioningURL = `${apiMarquetURI}/subscriptions/v1`
export const cognitoUri = process.env.REACT_APP_URL_DOMAIN_NAME === `app` ? `${apiMarquetURI}/cognito-subscriptions/v1` : `${apiMarquetURI}/stage-cognito-subscriptions/v1`
export const cognitoUri2 = process.env.REACT_APP_URL_DOMAIN_NAME === `app` ? `${apiMarquetURI}/cognito-admin/v1` : `${apiMarquetURI}/stage-cognito-admin/v1`

export const appName = process.env.REACT_APP_NAME;

export const customerKey = "sp__customer";
export const authKey = "sp__auth";

export const isDevEnv = process.env.REACT_APP_URL_DOMAIN_NAME === `app` ? false:true;